import { ChangeDetectorRef, Component, effect, Input, SimpleChanges } from '@angular/core';
import { ReportOccupancyRentalV2Constants } from './report-occupancy-rental-v2.constants';
import { SharedService } from 'src/app/common/services/shared.service';
import { ReportOccupancyRentalV2Service } from './report-occupancy-rental-v2.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import moment from 'moment';
import { ReportService } from 'src/app/reports/services/report.service';
import { ReportsChartEnum } from 'src/app/reports/models/enums/reports.enum';
import { OccupancyRentalV2MenuEnum } from './report-occupancy-rental-v2.enum';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { UnitTypeEnum } from '../../models/unit-type-enum';
// import { StoreService } from 'src/app/common/services/store.service';
import { AlertService } from 'src/app/common/components/alert/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { countryCode } from 'src/app/common/constants/common.contants';
// import { ReportTableDropdown } from '../../models/reports.model';
import { DecimalPipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-report-occupancy-rental-v2',
  templateUrl: './report-occupancy-rental-v2.component.html',
  styleUrls: ['./report-occupancy-rental-v2.component.scss']
})
export class ReportOccupancyRentalV2Component {
  RYDCHECK = environment.RYDCHECK;
  isSaudiCheck = false;
  countryListCode = countryCode
  @Input() isPremium: boolean = false;
  @Input() params: any;
  @Input() multi_story_residential: boolean = false;
  overViewMenu = ReportOccupancyRentalV2Constants.overViewMenu;
  occupancyRentalMenuEnum = OccupancyRentalV2MenuEnum;
  chartView = ReportsChartEnum;
  UnitTypeEnum = UnitTypeEnum;

  placeCode: string = '';
  currentScroll: any = '';
  overviewAverageLoading = false;
  overviewOccLoading = false;
  overviewLoading = false;
  overviewGradeLoading = false;
  overviewGraphLoading = false;
  averageData: any = {};
  occupancyData: any = {};
  averageGradeData: any[] = [];
  occupancyGradeData: any[] = [];
  averageTotalGradeValue: any = 0;
  occupancyTotalGradeValue: any = 0;
  overviewChartData: any = {};
  placeName = '';
  CurrencyCode: string = '';
  selectedChartValue: any[] = [];
  // officeRentOption: string = 'officeRentOption';
  moreText: any;
  langName: any;
  sqm_unit: string = '';
  isFirstTime = true;
  isChart = true;
  retailRentalChartReport: any[] = [];
  userInfo: any = 0;
  downloadLoading: any = {
    a: false,
    b: false,
    c: false,
    d: false,
    f: false
  };

  residentialGradeCount: number = 0;
  residentialGradeUnitsCount: number = 0;
  residentialGradeLoading: boolean = false;
  residentialGradeData: any = [];

  residentialTypeCount: number = 0;
  residentialTypeUnitCount: number = 0;
  residentialTypeLoading: boolean = false;
  residentialTypeData: any = [];

  commercialGradeCount: number = 0;
  commercialGradeUnitCount: number = 0;
  commercialGradeLoading: boolean = false;
  commercialGradeData: any = [];

  commercialSizeCount: number = 0;
  commercialSizeUnitCount: number = 0;
  commercialSizeLoading: boolean = false;
  commercialSizeData: any = [];

  transactionCount: number = 0;
  transactionpropertiesCount:number = 0;
  transactionLoading: boolean = false;
  transactionData: any = [];

  residentialGradeColumns = ReportOccupancyRentalV2Constants.residentialGradeColumns;

  residentialTypeColumns = ReportOccupancyRentalV2Constants.residentialTypeColumns;

  commercialGradeColumns = ReportOccupancyRentalV2Constants.commercialGradeColumns;

  commercialSizeColumns = ReportOccupancyRentalV2Constants.commercialSizeColumns;

  transactionColumns = ReportOccupancyRentalV2Constants.transactionColumns;

  showPropertyDetails: boolean = false;
  propertyInfo = null;

  transactionPropertyDetails$ = new Subscription();
  activeTab: any;
  tableName: any;
  activeTabName: string = 'property';
  globalContants = GlobalContants;
  private destroy$ = new Subject<void>(); // Subject to trigger unsubscribe
  retailRentalChartReportArray: any = [];

  queryParams: any;
  routeSub$: Subscription = new Subscription();

  constructor(
    public sharedService: SharedService,
    private occupancyService: ReportOccupancyRentalV2Service,
    public reportService: ReportService,
    private alertService: AlertService,
    public translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private decimalPipe: DecimalPipe,
    private activatedRoute:ActivatedRoute
  ) {

    effect(() => { this.activeTab = this.sharedService.activeTab() });
    this.sqm_unit = 'reports.' + GlobalContants.keySymbolContants.squareMeterUnit;
    this.sharedService.language$.subscribe(lang => {
      this.langName = lang;
      if (lang && !this.isFirstTime) {
        this.getReports();
        this.isChart = false;
        // this.storeService.clear(this.officeRentOption);
      }
    })
    //Update Column Monthly/Annual Properties Table
    if (this.sharedService.priceCalculation$() === this.sharedService.priceYearly) {
      const columnsToUpdate = [
        { header: 'rental_rate', columnName: 'reports.annual_rental_rate' }
      ];
      //Residential Units - Grade wise Table
      columnsToUpdate.forEach(column => {
        const targetColumn = this.residentialGradeColumns.find(x => x.header === column.header);
        if (targetColumn) {
          targetColumn.columnName = column.columnName;
        }
        //Residential Units - Type wise
        const targetColumnResidentialType = this.residentialTypeColumns.find(x => x.header === column.header);
        if (targetColumnResidentialType) {
          targetColumnResidentialType.columnName = column.columnName;
        }
      });
    }
  }

  ngOnInit() {
    this.routeSub$ = this.activatedRoute.queryParams.subscribe((params) => {
      this.queryParams = { ...params };
      let year = this.reportService.yearMaxValue(this.queryParams.year);
        this.occupancyService.residentialGradePayload.year = year;
        this.occupancyService.residentialTypePayload.year = year;
        this.occupancyService.commercialGradePayload.year = year;
        this.occupancyService.commercialSizePayload.year = year;
        this.occupancyService.transactionPayload.year = year;
    })

    this.isSaudiCheck = this.sharedService.getStoreValue(GlobalContants.StoreKey.countryCode) === countryCode.saudi;

    this.placeCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode);
    this.placeName = this.sharedService.getStoreValue(GlobalContants.StoreKey.PlaceName);
    this.CurrencyCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode);
    this.userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
    this.getReports();
    this.transactionPropertyDetails();
    this.isFirstTime = false;
    if (!this.isPremium) {
      this.overViewMenu = this.overViewMenu.filter(x => x.name !== OccupancyRentalV2MenuEnum.unitRentalTransaction);
    }
    //In Saudi Occupancy column remove
    if (this.isSaudiCheck) {
      const occupancyCol = 'occupancy';
      const filterOccupancy = (col: { header: string }) => col.header !== occupancyCol;
      this.residentialGradeColumns = this.residentialGradeColumns.filter(filterOccupancy);
      this.residentialTypeColumns = this.residentialTypeColumns.filter(filterOccupancy);
      this.commercialGradeColumns = this.commercialGradeColumns.filter(filterOccupancy);
      this.commercialSizeColumns = this.commercialSizeColumns.filter(filterOccupancy);
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['params'] && changes['params'].currentValue && !changes['params'].firstChange) {
      this.occupancyService.residentialGradePayload.pageNumber = 0;
      this.occupancyService.residentialTypePayload.pageNumber = 0;
      this.occupancyService.commercialGradePayload.pageNumber = 0;
      this.occupancyService.commercialSizePayload.pageNumber = 0;
      this.occupancyService.transactionPayload.pageNumber = 0;
      this.propertyInfo = null;
      this.showPropertyDetails = false;
      this.getReports();
    }
  }
  // @HostListener('window:beforeunload', ['$event'])
  // beforeUnload(): void {
  //   this.storeService.add(this.officeRentOption, this.selectedChartValue);
  // }


  lastClickedTable(event: Event, table: any) {
    this.tableName = table
  }
  /**
   * All Rports api call
  */
  getReports() {
    this.destroy$.next();
    this.getOverviewAverage();
    this.getOverviewOcc();
    this.getOverviewGraph();
    this.getResidentialGradeData();
    this.getResidentialTypeData();
    this.getcommercialGradeData();
    this.getcommercialSizeData();
    if (this.isPremium) this.getTransactionData();
  }
  /**
   * Property Details
   */
  transactionPropertyDetails() {
    this.transactionPropertyDetails$ = this.reportService.transactionPropertyDetails.subscribe((data) => {

      if (data) {
        this.showPropertyDetails = true;
        this.propertyInfo = data;
      } else {
        this.showPropertyDetails = false;
        this.propertyInfo = null;
      }
    });
  }
  /**
   * Overview all type Data
   */
  getOverviewAverage() {
    this.overviewAverageLoading = true;
    this.occupancyService.getOverview()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        {
          next: (res: any) => {
            this.overviewAverageLoading = false;
            if (res.status === 200) {
              this.averageData = res.data;
              this.averageGradeData = this.averageData.average_rate;
               if(!this.averageData?.min_date || !this.averageData?.max_date){
                this.averageData['untillDate'] = this.averageData.as_of_date ? moment.utc(this.averageData.as_of_date).local().format('DD MMM YYYY') : null;
               }
            } else {
              this.averageGradeData = [];
              this.averageData = {}
            }
          },
          error: (error: any) => {
            this.overviewAverageLoading = false;
            this.averageGradeData = [];
            this.averageData = {}
          }
        }
      )
  }
  /**
   * Overview Occupancy all type Data
   */
  getOverviewOcc() {
    this.overviewOccLoading = true;
    this.occupancyService.getOverviewOcc()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        {
          next: (res: any) => {
            this.overviewOccLoading = false;
            if (res.status === 200) {
              this.occupancyData = res.data.occupancy;
              if (!this.occupancyData?.min_date || !this.occupancyData?.max_date) {
                this.occupancyData['untillDate'] = this.occupancyData.as_of_date ? moment.utc(this.occupancyData.as_of_date).local().format('DD MMM YYYY') : null;
              }
              let overviewOccData: any = { ...this.reportService.getPercentageOverview(res.data.occupancy.grade) };
              this.occupancyGradeData = this.barSortData(overviewOccData);
            } else {
              this.occupancyGradeData = [];
              this.occupancyData = {}
            }
          },
          error: (error: any) => {
            this.overviewOccLoading = false;
            this.occupancyGradeData = [];
            this.occupancyData = {}
          }
        }
      )
  }
  /**
   * Overview year chart
   */
  getOverviewGraph() {
    this.overviewGraphLoading = true;
    this.occupancyService.getOverviewGraph()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (res.status === 200) {
            this.overviewChartData = res.data;

            const keyGroups = this.sharedService.sortGrades(Object.keys(this.overviewChartData));
            this.selectedChartValue = keyGroups.slice(0, 3);

            // Transform the data
            Object.keys(this.overviewChartData).forEach((key) => {
              let data = this.overviewChartData[key];
              this.overviewChartData[key] = data.map((obj: any) => ({
                category: obj.year.toString(),
                value: obj.count,
                name: key
              }));
            });
            // Update the retail rental chart report
            this.retailRentalChartReport = Object.keys(this.overviewChartData)
              .filter(key => this.selectedChartValue.includes(key))
              .reduce((obj: any, key: any) => {
                obj[key] = this.overviewChartData[key];
                return obj;
              }, {});
            this.retailRentalChartReportArray = this.sharedService.sortObjectByGrades(this.retailRentalChartReport);
            setTimeout(() => this.moreText = this.reportService.optionsCountDropdown(this.selectedChartValue));
            this.cdr.detectChanges();
          } else {
            this.overviewChartData = null;
          }
          this.overviewGraphLoading = false;
        },
        error: (error: any) => {
          this.overviewGraphLoading = false;
          this.overviewChartData = null;
        }
      });
  }
  /**
   * Residential Units - Grade wise
   */
  getResidentialGradeData() {
    this.residentialGradeLoading = true;
    this.occupancyService.getResidentialGrade(this.occupancyService.residentialGradePayload)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        {
          next: (res: any) => {
            if (res.status === 200) {

               this.residentialGradeData = this.reportService.setTableDataSource(res.data);
              if (this.occupancyService.residentialGradePayload.pageNumber == 0) {
                this.residentialGradeCount = res.count;
                this.residentialGradeUnitsCount = res.units_count;
              }
            } else {
              this.residentialGradeCount = 0;
              this.residentialGradeUnitsCount = 0;
              this.residentialGradeData = [];
            }
            this.residentialGradeLoading = false;
          },
          error: (error: any) => {
            this.residentialGradeData = [];
            this.residentialGradeCount = 0;
            this.residentialGradeUnitsCount = 0;
            this.residentialGradeLoading = false;
          }

        }
      )
  }
  /**
   * Residential Units - Type wise
   */
  getResidentialTypeData() {
    this.residentialTypeLoading = true;
    this.occupancyService.getResidentialType(this.occupancyService.residentialTypePayload)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        {
          next: (res: any) => {
            if (res.status === 200) {

               this.residentialTypeData = this.reportService.setTableDataSource(res.data);
              if (this.occupancyService.residentialTypePayload.pageNumber == 0) {
                this.residentialTypeCount = res.count;
                this.residentialTypeUnitCount = res.units_count;
              }
            } else {
              this.residentialTypeCount = 0;
              this.residentialTypeUnitCount = 0;
              this.residentialTypeData = [];
            }
            this.residentialTypeLoading = false;
          },
          error: (error: any) => {
            this.residentialTypeData = [];
            this.residentialTypeCount = 0;
            this.residentialTypeUnitCount = 0;
            this.residentialTypeLoading = false;
          }

        }
      )
  }
  /**
   * Commercial Units - Grade wise
   */
  getcommercialGradeData() {
    this.commercialGradeLoading = true;
    this.occupancyService.getCommercialGrade(this.occupancyService.commercialGradePayload)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        {
          next: (res: any) => {
            if (res.status === 200) {
              this.commercialGradeData = this.reportService.setTableDataSource(res.data);
              if (this.occupancyService.commercialGradePayload.pageNumber == 0) {
                this.commercialGradeCount = res.count;
                this.commercialGradeUnitCount = res.units_count;
              }
            } else {
              this.commercialGradeCount = 0;
              this.commercialGradeUnitCount = 0;
              this.commercialGradeData = [];
            }
            this.commercialGradeLoading = false;
          },
          error: (error: any) => {
            this.commercialGradeData = [];
            this.commercialGradeCount = 0;
            this.commercialGradeUnitCount = 0;
            this.commercialGradeLoading = false;
          }

        }
      )
  }
  /**
   * Commercial Units - Size wise
   */
  getcommercialSizeData() {
    this.commercialSizeLoading = true;
    this.occupancyService.getCommercialSize(this.occupancyService.commercialSizePayload)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        {
          next: (res: any) => {
            if (res.status === 200) {
              this.commercialSizeData = this.reportService.setTableDataSource(res.data);;
              if (this.occupancyService.commercialSizePayload.pageNumber == 0) {
                this.commercialSizeCount = res.count;
                this.commercialSizeUnitCount = res.units_count;
              }
            } else {
              this.commercialSizeCount = 0;
              this.commercialSizeUnitCount = 0;
              this.commercialSizeData = [];
            }
            this.commercialSizeLoading = false;
          },
          error: (error: any) => {
            this.commercialSizeData = [];
            this.commercialSizeCount = 0;
            this.commercialSizeUnitCount = 0;
            this.commercialSizeLoading = false;
          }

        }
      )
  }
  /**
   * Unit Rental Transaction
   */
  // Helper function to format range without null checks
  formatRange(min:any, max:any) {
    return min === max ? this.decimalPipe.transform(min) : this.reportService.rangeToNumberFor(`${min} - ${max}`);
  }
  getTransactionData(type: string = "") {
    this.transactionLoading = true;
    this.occupancyService.getTransactionSize(this.occupancyService.transactionPayload, type)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        {
          next: (res: any) => {
            if (res.status === 200) {
              if (res.data) {
                let cols = [
                  'unit_size',
                  'rental_lumpsum',
                  'rental_rate'
                ]
                res.data.map((el: any) => {
                  Object.keys(el).map((e: any) => {
                    // if (cols.includes(e)) {

                      // Apply formatting for each min-max pair
                      el['unit_size'] = this.formatRange(el.unit_size_min, el.unit_size_max);
                      el['rental_lumpsum'] = this.formatRange(el.rental_lumpsum_min, el.rental_lumpsum_max);
                      el['rental_rate'] = this.formatRange(el.rental_rate_min, el.rental_rate_max);

                      // el[e] = this.reportService.rangeToNumberFor(el[e]);
                    // }
                    if (el.details && el.details.length > 0) {
                      el.details.map((detail: any) => {
                        Object.keys(detail).map((key: any) => {
                          detail['unit_size'] = this.formatRange(detail.unit_size_min, detail.unit_size_max);
                          detail['rental_lumpsum'] = this.formatRange(detail.rental_lumpsum_min, detail.rental_lumpsum_max);
                          detail['rental_rate'] = this.formatRange(detail.rental_rate_min, detail.rental_rate_max);
                          // if (cols.includes(key)) {
                            // detail[key] = this.reportService.rangeToNumberFor(detail[key]);
                          // }
                        })
                      })
                    }
                  })
                })
              }
              // this.transactionData = res.data;
              this.transactionData = this.reportService.setTableDataSource(res.data);
              if (this.occupancyService.transactionPayload.pageNumber == 0) {
                this.transactionCount = res.count;
                this.transactionpropertiesCount = res.total_properties;
              }
            } else {
              this.transactionCount = 0;
              this.transactionpropertiesCount = 0;
              this.transactionData = [];
            }
            this.transactionLoading = false;
          },
          error: (error: any) => {
            this.transactionData = [];
            this.transactionCount = 0;
            this.transactionpropertiesCount = 0;
            this.transactionLoading = false;
          }

        }
      )
  }
  onPageEvent(e: any, report: any) {
    if (e.previousPageIndex !== e.pageIndex) {
      if (report === this.occupancyRentalMenuEnum.residentialUnitsGradeWise) {
        this.occupancyService.residentialGradePayload.pageNumber = (e.pageSize * e.pageIndex);
        this.getResidentialGradeData();
      } else if (report === this.occupancyRentalMenuEnum.residentialUnitsTypeWise) {
        this.occupancyService.residentialTypePayload.pageNumber = (e.pageSize * e.pageIndex);
        this.getResidentialTypeData();
      } else if (report === this.occupancyRentalMenuEnum.commercialUnitsGradeWise) {
        this.occupancyService.commercialGradePayload.pageNumber = (e.pageSize * e.pageIndex);
        this.getcommercialGradeData();
      } else if (report === this.occupancyRentalMenuEnum.commercialUnitsSizeWise) {
        this.occupancyService.commercialSizePayload.pageNumber = (e.pageSize * e.pageIndex);
        this.getcommercialSizeData();
      } else if (report === this.occupancyRentalMenuEnum.unitRentalTransaction) {
        this.occupancyService.transactionPayload.pageNumber = (e.pageSize * e.pageIndex);
        this.getTransactionData();
      }
    }
  }
  sortData(event: any, report: any) {
    let sort = {
      column: event.active,
      order: event.direction
    }
    if (report === this.occupancyRentalMenuEnum.unitRentalTransaction) {
      this.occupancyService.transactionPayload.pageNumber = 0;
      this.occupancyService.transactionPayload.sort_order = JSON.stringify(sort).replace(/[+]/g, '%2B');
      this.getTransactionData();
    }
  }
  downloadExcel(event: any, type: string, key: any) {
    this.downloadRentalReport(type, key);
  }
  downloadRentalReport(type: string, key: any) {
    this.downloadLoading[key] = true;
    this.occupancyService.downloadInvestmentReport(type, this.userInfo?.user_id).subscribe(
      {
        next: (res: any) => {
          this.downloadLoading[key] = false;
          if (res.status === 200) {
            const downloadUrl = `${this.sharedService.downloadExcelPath()}?file_name=${res.data}&city_code=${this.placeCode.toLowerCase()}&module_name=investment_residential`;
            this.sharedService.downloadExcelUrl(downloadUrl);
            this.alertService.success(this.translate.instant('reports.downloadRequestSubmitted'));

          } else {
            this.alertService.warn(res.message)
          }
        },
        error: (error: any) => {
          this.downloadLoading[key] = false;
        }
      }
    )
  }
  /**
   *
   * @param data
   * @returns
   * Common horizontalbar sorting
   */
  barSortData(data: any) {
    let overviewArray: any = Object.entries(data);
    return overviewArray.sort((a: any, b: any) => b[1].category - a[1].category);
  }
  /**
   *
   * @param e
   * @param value
   * @returns
   * On clicking the dropdown, the chart will be added or removed
   */
  selectChart(e: any, value: any) {
    let data = this.reportService.selectChart(
        this.selectedChartValue,
        this.overviewChartData,
        e,
        value
    );
    if (data) this.retailRentalChartReportArray = this.sharedService.sortObjectByGrades(data);
    this.overviewGraphLoading = false;
    setTimeout(() => this.moreText = this.reportService.optionsCountDropdown(this.selectedChartValue));
  }
  getReportKeys(): string[] {
    if (this.overviewChartData) {
      let sortedS = Object.keys(this.overviewChartData);
      return this.sharedService.sortGrades(sortedS)
    }
    return [];
  }
  /**
   *
   * @param menu
   * if click menu scroll particular div
   */
  menuChangeValue(menu: any) {
    this.currentScroll = menu.name;
    this.activeTab = menu.name;
    setTimeout(() => {
      this.scrollPoint(menu.name);
    })
  }
  scrollPoint(menu: string) {
    this.sharedService.scrollMenu(menu);
  }
  selectedYear(data: any) {
    if (data.reportType === 'residentialGrade') {
      this.occupancyService.residentialGradePayload.pageNumber = 0;
      this.occupancyService.residentialGradePayload.year = data.year;
      this.getResidentialGradeData();
    } else if (data.reportType === 'residentialType') {
      this.occupancyService.residentialTypePayload.pageNumber = 0;
      this.occupancyService.residentialTypePayload.year = data.year;
      this.getResidentialTypeData();
    } else if (data.reportType === 'commercialGrade') {
      this.occupancyService.commercialGradePayload.pageNumber = 0;
      this.occupancyService.commercialGradePayload.year = data.year;
      this.getcommercialGradeData();
    } else if (data.reportType === 'commercialSize') {
      this.occupancyService.commercialSizePayload.pageNumber = 0;
      this.occupancyService.commercialSizePayload.year = data.year;
      this.getcommercialSizeData();
    } else if (data.reportType === 'transaction') {
      this.occupancyService.transactionPayload.pageNumber = 0;
      this.occupancyService.transactionPayload.year = data.year;
      this.getTransactionData();
    }
  }
  getKeys(obj: any): string[] {
    return Object.keys(obj);
  }
  ngOnDestroy() {
    this.destroy$.next(); // Emit signal to unsubscribe
    this.destroy$.complete(); // Clean up the Subject
    this.transactionPropertyDetails$.unsubscribe();
    this.routeSub$.unsubscribe();
  }

}
